import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'ramda';
import { useTranslation } from 'react-i18next';
import Loader from 'react-loader-spinner';

import { useGetAudios } from 'components/audio/service';
import { useFormInput } from 'utils/hooks';
import { useRedirectByRole } from 'utils/hooks/useRedirectByRole';
import { ROUTES, ROLES } from 'utils/constants';

import LeftMenu from 'components/LeftMenu';
import Header from 'components/Header';
import SearchFilter from 'components/SearchFilter';
import SolidButton from 'components/SolidButton';
import AllAudios from 'components/audio/AllAudios';
import NoProductsFound from 'components/Forms/NoFormsFound';
import { NoMembers } from 'components/EmptyState';

import noAudios from 'assets/images/no-data.svg';

const AudioList = () => {
  useRedirectByRole([ROLES.SUPER_CLINIC]);
  const { t } = useTranslation();
  const { push } = useHistory();

  const { allAudio, loading } = useGetAudios();

  const [audioList, setAudioList] = useState([]);
  const searchAudio = useFormInput('');
  const { value = '' } = searchAudio;

  useEffect(() => {
    let temporal = allAudio;
    if (value) {
      temporal = allAudio.filter((audio) => {
        const { title } = audio;
        return `${title}`.toLowerCase().includes(value.toLowerCase());
      });
    }
    setAudioList(temporal);
  }, [allAudio, value]);

  const handleChangeRoute = () => {
    push(ROUTES.CREATE_AUDIO);
  };

  return (
    <>
      <section className="d-flex">
        <LeftMenu />
        <div className="dashboard__main">
          <Header title={t('leftMenuHeader.audioList')} shadow />
          <div className="templates__content dashboard__content--patients">
            {!loading && isEmpty(allAudio) && (
              <NoMembers
                title={t('audioList.emptyState.title')}
                subtitle={t('audioList.emptyState.description')}
                button={t('audioList.createButton')}
                handleClick={handleChangeRoute}
                image={noAudios}
              />
            )}
            {!loading && !isEmpty(allAudio) && (
              <div className="forms">
                <div className="forms__search">
                  <SearchFilter searchItems={searchAudio} placeholder={t('placeholder.audio')} />
                  <SolidButton onClick={handleChangeRoute} className="slim">
                    {t('button.create')} Audio
                  </SolidButton>
                </div>
                <table>
                  <thead>
                    <tr>
                      <th style={{ width: '30%' }}>{t('audioList.tableHeader.title')}</th>
                      <th style={{ width: '60%' }}>{t('audioList.tableHeader.description')}</th>
                      <th style={{ width: '10%' }}> </th>
                    </tr>
                  </thead>
                  <tbody>
                    <AllAudios audios={audioList} />
                    {isEmpty(audioList) && <NoProductsFound />}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </section>
      <Loader className="spinner" type="ThreeDots" color="#495fd7" height={100} width={100} visible={loading} />
    </>
  );
};

export default AudioList;
